import { LOCALE_ID, NgModule } from '@angular/core';
import { IMAGE_LOADER, ImageLoaderConfig, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { rtirQaInterceptor } from '@apiShared/interceptors/rtir-qa.interceptor';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';

import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ClassHelperModule } from '@class/class-helper.module';
import { provideClientHydration } from '@angular/platform-browser';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';

import { environment } from '@enviroment/environment';
import { LoadingOverlayComponent } from '@core/loading-overlay/loading-overlay.component';

registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ClassHelperModule,
    LazyLoadImageModule,
    RecaptchaV3Module,
    LoadingOverlayComponent,
  ],
  bootstrap: [AppComponent],
  providers: [
    provideClientHydration(),
    provideHttpClient(withFetch(), withInterceptors([rtirQaInterceptor])),
    { provide: LOCALE_ID, useValue: 'es' },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.RECAPTCHA_V3_SITE_KEY,
    },
    {
      provide: IMAGE_LOADER,
      useValue: (config: ImageLoaderConfig) => {
        return `https://static.mejorcdt.com/assets/${config.src}`;
      },
    },
  ],
})
export class AppModule {}
